import {h, Fragment} from "preact"
import { useContext, useEffect, useState } from "preact/hooks";
import { createContext } from "preact";
import { getCookie, setCookie } from "../../utils"
import { useBreakpoints } from '../hooks/useBreakpoints'
import { useCustomConfig } from '../hooks/useCustomConfig'

const GridLayoutContext = createContext();

const useGridLayout = () => {
  return useContext(GridLayoutContext);
};

const cookieKey = 'gridSize'

const GridLayoutProvider = ({ children }) => {
  
  const { customConfig } = useCustomConfig()
  const { screen } = useBreakpoints()
  const [gridSize, setGridSizeState] = useState(2);
  
  useEffect(() => {
    if (screen) {
      const saved = getCookie(`${cookieKey}_${screen}`);
      setGridSize(saved ? saved : getDefaultItemsPerRow(screen))
    }
  }, [screen])

  const getDefaultItemsPerRow = (screen) => {
    let itemsPerRow = 0
    if (screen === 'desktop') {
      itemsPerRow = customConfig.grid.itemsPerRowDesktop
    } else if (screen === 'tablet') {
      itemsPerRow = customConfig.grid.itemsPerRowTablet
    } else if (screen === 'mobile') {
      itemsPerRow = customConfig.grid.itemsPerRowMobile
    }
    return itemsPerRow
  }

  const setGridSize = (size) => {
    setGridSizeState(size);
    setCookie(`${cookieKey}_${screen}`, size)
  };

  if (!screen) return

  return (
    <GridLayoutContext.Provider
      value={{
        gridSize,
        setGridSize
      }}
    >
      {children}
    </GridLayoutContext.Provider>
  );
};

export { GridLayoutProvider, useGridLayout };